import StatisticsGeneralPage from "./statisticsGeneralPage.component"

export default StatisticsGeneralPage
